import { KeyboardArrowDown } from "@mui/icons-material";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Link,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Grid,
} from "@mui/material";
import { AppBarSubOption } from "./AppBarSubOption";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function AppBarOption({ title, options, index, selectedIndex, handleClick2 }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  //const [selectedIndex, setSelectedIndex] = React.useState(null);
  const navigate = useNavigate();
  const [color, setColor] = useState('primary');
  const [variant, setVariant] = useState('contained');

  const handleClick = () => {
    //console.info(`You clicked ${options[selectedIndex]}`);
    if(options[index]?.childs !== undefined){
      console.log('tiene hijos')
      handleClick2(index);
    }
    else
    {
      handleClick2(index);
    }
  };

  useEffect(()=>{
    if(index === selectedIndex){
      setColor('inherit');
      setVariant('outlined');
    }
    else{
      setColor('primary');
      setVariant('contained');
    }
  }, [selectedIndex])

  const handleMenuItemClick = (event, index) => {
    //setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    //handleClick2(index);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="split button"
        sx={{ boxShadow: 0 }}
      >
        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          color={color}
          variant={variant}
          onClick={handleToggle}
          sx={{ boxShadow: 0, display: { xs: "none", sm: "flex" } }}
        >
          {title}
          <KeyboardArrowDown />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-start"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: "left",
              // transformOrigin:
              //     placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <Link
                      textAlign="center"
                      href={option.link}
                      className="UserMenu"
                      key={option + index}
                      onClick={handleClick}
                    >
                      {option.childs 
                      ?
                      <AppBarSubOption
                            title={option.name}
                            options={option.childs}
                            key={index}
                          />
                      : <MenuItem /* onClick={handleCloseUserMenu} */>
                        {option.name}
                      </MenuItem>
                      }
                    </Link>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export { AppBarOption };
